/* @ngInject */
export default function combinationDisplayController() {
  let ctrl = this

  ctrl.$onInit = () => {
    ctrl.showProductPrice = ctrl.showProductPrice === undefined ? true : ctrl.showProductPrice
  }
}
